export const initialState = () => ({
  loading: false,
  query: {
    search: '',
    page: 1,
  },
  data: {
    data: [],
    total: 0,
  },
});

export default {
  ...initialState(),
};
